import {
  Divider,
  Fade, IconButton, List,
  ListItem,
  ListItemText, Paper,
  Slide, Typography, withStyles
} from '@material-ui/core';
import AirlineSeatFlatAngled from '@material-ui/icons/AirlineSeatFlatAngled';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Autorenew from '@material-ui/icons/Autorenew';
import Receipt from '@material-ui/icons/Receipt';
import AspectRatio from '@material-ui/icons/AspectRatio';
import Person from '@material-ui/icons/Person';
import Payment from '@material-ui/icons/Payment';
import AssignmentReturn from '@material-ui/icons/AssignmentReturn';
import Assignment from '@material-ui/icons/Assignment';
import Face from '@material-ui/icons/Face';

import { inject, observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});
@inject('usuarioStore')
@observer
class FinanceiroPrincipal extends React.Component {
  render () {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Link to='/dashboard' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Financeiro</Typography>
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <List>
          <Divider />
            <Link to={'/financeiro/calculoCoparticipacao'} className={classes.link}>
              <Fade timeout={600} in>
                <ListItem button key='0'>
                  <MonetizationOn />
                  <ListItemText
                    primary='Cálculo de Coparticipação - Médico'
                    secondary='Calcula a coparticipação dos Demonstrativos de pagamento Médicos' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/financeiro/calculoCoparticipacaoOdonto'} className={classes.link}>
              <Fade timeout={1000} in>
                <ListItem button key='0'>
                  <AirlineSeatFlatAngled />
                  <ListItemText
                    primary='Cálculo de Coparticipação - Odontológico'
                    secondary='Calcula a coparticipação dos Demonstrativos de pagamento Odontológicos' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
          </List>
        </Paper>
        <Paper className={classes.root} elevation={1}>
          <List>
          <Divider />
            <Link to={'/financeiro/acertoMensalidade'} className={classes.link}>
              <Fade timeout={1400} in>
                <ListItem button key='0'>
                  <Autorenew />
                  <ListItemText
                    primary='Acerto de mensalidades'
                    secondary='Acertos financeiros em mensalidades de beneficiários' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/financeiro/acertoCoparticipacao'} className={classes.link}>
              <Fade timeout={1800} in>
                <ListItem button key='0'>
                  <Receipt />
                  <ListItemText
                    primary='Acerto de coparticipações'
                    secondary='Acertos financeiros em coparticipações de beneficiários e prestadores' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/financeiro/acertosDiversos'} className={classes.link}>
              <Fade timeout={2100} in>
                <ListItem button key='0'>
                  <AspectRatio />
                  <ListItemText
                    primary='Acertos Diversos (Reembolso, Funeral, Diárias e Transporte)'
                    secondary='Acertos financeiros para as rubricas de Reembolso, Funeral, Diárias e Transporte' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            </List>
            </Paper>
            <Paper className={classes.root} elevation={1}>
            <List>
            <Divider />
            <Link to={'/financeiro/dividaServDesligado'} className={classes.link}>
              <Fade timeout={2400} in>
                <ListItem button key='0'>
                  <Person />
                  <ListItemText
                    primary='Dívidas de Servidores Desligados'
                    secondary='Lançamento de Dívidas de Servidores Desligados' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/financeiro/dividaServDesligadoPagto'} className={classes.link}>
              <Fade timeout={2800} in>
                <ListItem button key='0'>
                  <Payment />
                  <ListItemText
                    disabled
                    primary='Pagamento de Dívidas de Servidores Desligados'
                    secondary='Pagamentos para Baixa de Dívidas de Servidores Desligados' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
          </List>
        </Paper>
        <Paper className={classes.root} elevation={1}>
            <List>
            <Divider />
            <Link to={'/financeiro/reembolsoMedico'} className={classes.link}>
              <Fade timeout={3200} in>
                <ListItem button key='0'>
                  <AssignmentReturn />
                  <ListItemText
                    primary='Cadastro de Reembolso Médico'
                    secondary='Lançamento de Reembolsos Médicos' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/financeiro/assistenciaOdontologica'} className={classes.link}>
              <Fade timeout={3600} in>
                <ListItem button key='0'>
                  <Assignment />
                  <ListItemText
                    primary='Assistência Odontológica'
                    secondary='Lançamento de Reembolsos Odontológicos' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/financeiro/dentista'} className={classes.link}>
              <Fade timeout={4000} in>
                <ListItem button key='0'>
                  <Face />
                  <ListItemText
                    primary='Cadastro de Dentistas/Consultórios'
                    secondary='Cadastro de Dentistas/Consultórios para fins de Assistência Odontológica' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
          </List>
        </Paper>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(FinanceiroPrincipal);
